import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Employee } from '../../shared/models/employee/employees.model';
import { AtlasAppId, EmployeePermissionType } from '../../shared/models/employee/employee-permissions-type.model';

@Injectable({ providedIn: 'root' })
export class EmployeeCacheService {
  public uid: string = '';
  public email: string = '';
  private permissions: string[] = [];
  private loaded = new ReplaySubject<void>(1);

  // Emits once the employee call comes back, so guards don't check before then
  public loaded$: Observable<void> = this.loaded.asObservable();

  public set = (employee?: Employee) => {
    this.uid = employee?.uid ?? '';
    this.email = employee?.username ?? '';
    this.permissions = (employee?.permissions ?? [])
      .filter(permission => permission.appId === AtlasAppId)
      .map(permission => permission.id);
    this.loaded.next();
  }

  public checkPermissions = (permissionsToCheck: EmployeePermissionType[]) =>
    this.permissions.includes(EmployeePermissionType.SuperAdmin) || permissionsToCheck.some(permission => this.permissions.includes(permission));
}
